import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide5 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={4}
      total={total}
      label="Document Engine"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(680px 520px at 72% 40%,rgba(216,182,46,.25),transparent 66%),repeating-linear-gradient(135deg,rgba(255,255,255,.06) 0 1px,transparent 1px 42px),#030403"
      }}
    >

      <h2>{t.title}</h2>
      
      <p className="lead">{t.body}</p>

      <div className="grid three wide">
        <div className="card">
          <span className="num">NF</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">TR</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">SV</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
      </div>
    </SlideShell>
  );
};


